const debug = require('./debug')

module.exports = {
	apiUrl: debug ? 'http://localhost:7000/api/v1' : 'http://ha.wa.ecansol.net:7000/api/v1',
	server: {}
}